import { Component, OnInit, Input, HostListener } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MdDialogRef } from '@angular/material';

import { MessageService } from 'app/services/messages.service';
import { SnackBarService } from 'app/services/snackbar.service';
import { unsavedFormCheck } from 'app/shared/validators/generic-validators';

import { EntityAuditService } from 'app/entities/audit/entity-audit.service';
import { EntityIdDetails } from './../../../shared/models/entity-id-details.model';

@Component({
    templateUrl: './add-audit-information.component.html',
})

/**
 * Dialog component to update task definition description through editor.
 */
export class AddAuditInformationComponent implements OnInit {
    auditInfoEditorForm: FormGroup;
    entityIdDetails: EntityIdDetails;

    constructor(private formBuilder: FormBuilder,
        public dialogRef: MdDialogRef<any>,
        private snackBarService: SnackBarService,
        private auditService: EntityAuditService) {
    }

    ngOnInit(): void {
        this.buildForm();
    }

    // TODO(jagpreet.singh): This function might get updated once REST is available.
    buildForm() {
        this.auditInfoEditorForm = this.formBuilder.group({
            auditInfoText: [{ value: '' }],
        });
    }

    // Method to submit the changes for Task Guide text.
    onSubmit({ value, valid }) {
        this.auditInfoEditorForm.disable();
        this.auditService.addJournalEntry(value.auditInfoText, this.entityIdDetails.entityId)
            .subscribe(response => {
                if (response.flagResult) {
                    this.dialogRef.close(response);
                }
                this.callSnackBarService(response);
            }, err => {
                this.callSnackBarService(err);
            }
            );
    }

    callSnackBarService(response: any) {
        this.snackBarService
            .showStatus(response,
            MessageService.ADD_AUDIT_DETAILS_SUCCESS,
            MessageService.ADD_AUDIT_DETAILS_FAILURE);
    }

    @HostListener('keydown', ['$event'])
    handleKeyboardEvent(event: KeyboardEvent) {
        unsavedFormCheck(event, this.dialogRef, this.auditInfoEditorForm);
    }
}



// WEBPACK FOOTER //
// ./src/app/entities/audit/addauditinformation/add-audit-information.component.ts